export enum TilingProtocol {
    WMTS = 'WMTS',
    TMS = 'TMS',
}
